import { validateField, validateRequiredFields, formatPhone } from '../../utils/form.js';
import { formStartEvent, formSubmitEvent, formCompletedEvent } from '../../utils/gtm.js';
import { getSessionInfo } from '../../utils/craft.js';

export default function contactForm() {
  const form = document.querySelector('#contact-form');
  const successMessage = document.querySelector('.form__success');

  if (!form) return;

  const formContainer = form.closest('.form-container');
  const inputs = form.querySelectorAll('input, textarea');
  let firstFocus = false;

  inputs.forEach(element => {
    element.addEventListener('blur', () => {
      if(element.value === '') return;
      validateField(element);
      if(element.type === 'tel') {
        element.value = formatPhone(element.value);
      }
    });
    element.addEventListener('focus', () => {
      if(!firstFocus) {
        window.pushGTMEvent(formStartEvent(form));
        firstFocus = true;
      }
    });
  });

  form.addEventListener('submit', (e) => {
    e.preventDefault();

    if(!firstFocus) {
      window.pushGTMEvent(formStartEvent(form));
      firstFocus = true;
    }

    if(typeof grecaptcha === 'undefined') {
      // eslint-disable-next-line no-undef
      grecaptcha = {};
    }

    // eslint-disable-next-line no-undef
    grecaptcha.ready(function() {
      // eslint-disable-next-line no-undef
      grecaptcha.execute(window.recaptchaKey, {action: 'submit'}).then(function(token) {
        getSessionInfo()
          .then(session => {
            const formData = new FormData(form);

            formContainer.classList.remove('error');
            formContainer.classList.add('submitting');

            formData.append(window.csrfTokenName, session.csrfTokenValue);
            formData.append('token', token);

            if (!validateRequiredFields(form)) {
              formContainer.classList.remove('submitting');
              formContainer.classList.add('error');
              return;
            }

            fetch(form.action, { method: 'POST', body: formData })
              .then(function(response) {
                if (response.status != 200) {
                  throw response.status;
                } else {
                  return response.json();
                }
              })
              .then(function(data) {
                if (data.success) {
                  formContainer.classList.add('submitted');
                  successMessage.focus();

                  if (window.innerWidth < 1024) {
                    formContainer.scrollIntoView({ behavior: "smooth", block: "start" });
                  }

                  window.pushGTMEvent(formSubmitEvent(form));
                  window.pushGTMEvent(formCompletedEvent(form));
                } else {
                  formContainer.classList.remove('submitting');
                  formContainer.classList.add('error');
                }
              })
              .catch(function(error) {
                console.log("Error: " + error);
              });
          });
      });
    });
  });
}
